// Initialize Firebase
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

var config = {
  apiKey: "AIzaSyA9bZUicHESM7DVHLxIA8HEYsu6uJ6tzxo",
  authDomain: "ecatlandingpage.firebaseapp.com",
  databaseURL: "https://ecatlandingpage.firebaseio.com",
  projectId: "ecatlandingpage",
  storageBucket: "ecatlandingpage.appspot.com",
  messagingSenderId: "979012537833"
};
firebase.initializeApp(config);
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;




